import { PollChoice } from '@/types/pollChoice'
import axios from 'axios'

export default async function updatePollChoice(
  payload: Pick<PollChoice, 'id' | 'poll_id' | 'sort' | 'label' | 'article_id'>
) {
  await axios.put(`/api/v1/poll-choice/${payload.id}/`, payload)
}
